import * as React from 'react';
import bonus from './assets/bonus.svg';
import discount from './assets/discount.svg';
import mortgage from './assets/mortgage.svg';
import * as styles from './PromosPreviewList.css';
import { IPromoInfo, EPromoType } from '../../types/promosPage';
import { PromoPreviewItem } from '../PromoPreviewItem';

interface IPromosPreviewProps {
  promos: IPromoInfo[];
}

export const PROMO_PREVIEW_ICON: { [key in EPromoType]: string | null } = {
  [EPromoType.Bonus]: bonus,
  [EPromoType.Discount]: discount,
  [EPromoType.Mortgage]: mortgage,
  [EPromoType.MaternalCapital]: null,
  [EPromoType.CianMortgage]: null,
  [EPromoType.Military]: null,
};

export const PromoPreviewList: React.FC<IPromosPreviewProps> = ({ promos }) => {
  return (
    <div className={styles['preview-list']}>
      {promos.map((promo, index) => {
        const icon = PROMO_PREVIEW_ICON[promo.promoType];

        return (
          <div key={index} className={styles['preview-item']}>
            <PromoPreviewItem icon={icon} />
          </div>
        );
      })}
    </div>
  );
};
